// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BJAl","colBig":"styles_colBig__1JId0","colSmall":"styles_colSmall__1_t3s"};